import React from "react";
import {BrowserRouter as Router, Route, Switch,} from "react-router-dom";
import './styles.css';
import Application from "./Components/Application";
import {
    QUEUE_NAME_CIS,
    QUEUE_NAME_GI,
    QUEUE_NAME_MAIN,
    QUEUE_NAME_RADIOLOGY,
    QUEUE_NAME_RN,
    QUEUE_NAME_BILLING,
    QUEUE_NAME_SHVI,
    QUEUE_NAME_BILLING_ES,
    QUEUE_NAME_GLP,
    QUEUE_NAME_FLOYD_RADIOLOGY,
    QUEUE_NAME_NAV_RADIOLOGY,
    QUEUE_NAME_ESTIMATES,
    QUEUE_NAME_NEUROLOGY,
} from './utils/constant'

export default function App() {
    return (
        <Router>
            <Switch>
                {/* --- Custom routes --- */}
                <Route path={process.env.PUBLIC_URL + "/MyGIAppointment"}
                    render={(props) => (
                        <Application {...props} startQueueName={QUEUE_NAME_GI} />
                    )}
                />
                <Route path={process.env.PUBLIC_URL + "/LiveChat"}
                       render={(props) => (
                           <Application {...props} startQueueName={QUEUE_NAME_MAIN} />
                       )}
                />
                <Route path={process.env.PUBLIC_URL + "/CIS"}
                       render={(props) => (
                           <Application {...props} startQueueName={QUEUE_NAME_CIS} />
                       )}
                />
                <Route path={process.env.PUBLIC_URL + "/Radiology"}
                       render={(props) => (
                           <Application {...props} startQueueName={QUEUE_NAME_RADIOLOGY} />
                       )}
                />
                <Route path={process.env.PUBLIC_URL + "/nurse-advice"}
                       render={(props) => (
                           <Application {...props} startQueueName={QUEUE_NAME_RN} />
                       )}
                />
                <Route path={process.env.PUBLIC_URL + "/glp"}
                       render={(props) => (
                           <Application {...props} startQueueName={QUEUE_NAME_GLP} />
                       )}
                />
                <Route path={process.env.PUBLIC_URL + "/Billing"}
                       render={(props) => (
                           <Application {...props} startQueueName={QUEUE_NAME_BILLING} />
                       )}
                />
                <Route path={process.env.PUBLIC_URL + "/Billing-es"}
                       render={(props) => (
                           <Application {...props} startQueueName={QUEUE_NAME_BILLING_ES} language={'es'}/>
                       )}
                />
                <Route path={process.env.PUBLIC_URL + "/SHVI"}
                       render={(props) => (
                           <Application {...props} startQueueName={QUEUE_NAME_SHVI} />
                       )}
                />
                <Route path={process.env.PUBLIC_URL + "/floyd-radiology"}
                       render={(props) => (
                           <Application {...props} startQueueName={QUEUE_NAME_FLOYD_RADIOLOGY} />
                       )}
                />
                <Route path={process.env.PUBLIC_URL + "/nav-radiology"}
                       render={(props) => (
                           <Application {...props} startQueueName={QUEUE_NAME_NAV_RADIOLOGY} />
                       )}
                />
                <Route path={process.env.PUBLIC_URL + "/estimates"}
                       render={(props) => (
                           <Application {...props} startQueueName={QUEUE_NAME_ESTIMATES} />
                       )}
                />
                <Route path={process.env.PUBLIC_URL + "/neurology"}
                       render={(props) => (
                           <Application {...props} startQueueName={QUEUE_NAME_NEUROLOGY} />
                       )}
                />
                {/*--- Main routes ---*/}
                {/* By queue name */}
                <Route path={process.env.PUBLIC_URL + "/queue/:queueName"} component={Application}/>
                {/* Referrals by queue and token */}
                <Route path={process.env.PUBLIC_URL + "/referrals/:queueName/:token"} component={Application}/>
                {/* Referrals by parameters:
                        @mrn: Patient MRN
                        @department: Appointment department
                        @ref: Patient referral number
                        @username: Patient name
                */}
                <Route path={process.env.PUBLIC_URL + "/:mrn?/:department?/:ref?/:username?"} component={Application}/>
            </Switch>
        </Router>
    );
}
